import { defineMessages } from 'react-intl-next';

export const messages: {
    emailButtonLabel: {
        defaultMessage: string;
        description: string;
        id: string;
    }; viewProfile: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	viewProfile: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card.view-profile',
		defaultMessage: 'View profile',
		description: "Copy for button that will take the user to the displayed user's profile",
	},
	emailButtonLabel: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card.email-button-label',
		defaultMessage: 'Copy email address',
		description:
			"Tooltip and a11y label to let the user know they can copy the user's email by interacting with the email icon button",
	},
});

export const timeUnitAgoMessages: {
    comment: {
        defaultMessage: string;
        description: string;
        id: string;
    }; edit: {
        defaultMessage: string;
        description: string;
        id: string;
    }; share: {
        defaultMessage: string;
        description: string;
        id: string;
    };
} = defineMessages({
	share: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card.shared-time-unit-ago-by',
		defaultMessage: 'Shared {relativeDate} by',
		description:
			'Used to tell the user how long ago the social signal happened, e.g. "Shared {2 days ago} by", "Shared {1 hour ago} by"',
	},
	comment: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card.commented-time-unit-ago-by',
		defaultMessage: 'Commented {relativeDate} by',
		description:
			'Used to tell the user how long ago the social signal happened, e.g. "Commented {2 days ago} by", , "Commented {1 hour ago} by"',
	},
	edit: {
		id: 'dynamic-cards-search-ui.search-page.social-signals.user-card.edited-time-unit-ago-by',
		defaultMessage: 'Edited {relativeDate} by',
		description:
			'Used to tell the user how long ago the social signal happened, e.g. "Edited {2 days ago} by", "Edited {1 hour ago} by"',
	},
});
